module.exports = __webpack_public_path__ + "img/works_beijing_xikemu_3.4b316288.jpg";